<template>
  <div class="header" @click="handleGetAllFilters()">
    <div class="topper">
      <dropdown
        :options="price.arrayOfObjects"
        :selected="price.name"
        :placeholder="t.label_price"
        v-on:updateOption="handlePrice"
        :key="itemsSelected.price.key"
      ></dropdown>
      <!-- <dropdown
        :options="percent_comission.arrayOfObjects"
        :selected="percent_comission.name"
        :placeholder="t.label_commission"
        v-on:updateOption="handlePercentComission"
        :key="itemsSelected.percent_comission.key"
      ></dropdown> -->
      <dropdown
        :options="country.arrayOfObjects"
        :selected="country.name"
        :placeholder="t.label_country"
        v-on:updateOption="handleCountry"
        :key="itemsSelected.country.key"
      ></dropdown>
      <dropdown
        :options="language.arrayOfObjects"
        :selected="language.name"
        :placeholder="t.label_language"
        v-on:updateOption="handleLanguage"
        :key="itemsSelected.language.key"
      ></dropdown>
      <dropdown
        :options="currency.arrayOfObjects"
        :selected="currency.name"
        :placeholder="t.label_coin"
        v-on:updateOption="handleCurrency"
        :key="itemsSelected.currency.key"
      ></dropdown>
      <dropdown
        :options="format.arrayOfObjects"
        :selected="format.name"
        :placeholder="t.label_niche"
        v-on:updateOption="handleFormat"
        :key="itemsSelected.format.key"
      ></dropdown>
    </div>
    <div class="footter">
      <div class="items">
        <div class="item__selected" v-if="itemsSelected.price.name">
          <span>{{itemsSelected.price.name}}</span>
          <span>
            <svg
              @click="handlePrice('del')"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                fill="#C6C2C2"
              />
            </svg>
          </span>
        </div>
        <div class="item__selected" v-if="itemsSelected.percent_comission.name">
          <span>{{itemsSelected.percent_comission.name}}</span>
          <span>
            <svg
              @click="handlePercentComission('del')"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                fill="#C6C2C2"
              />
            </svg>
          </span>
        </div>
        <div class="item__selected" v-if="itemsSelected.country.name">
          <span>{{itemsSelected.country.name}}</span>
          <span>
            <svg
              @click="handleCountry('del')"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                fill="#C6C2C2"
              />
            </svg>
          </span>
        </div>
        <div class="item__selected" v-if="itemsSelected.language.name">
          <span>{{itemsSelected.language.name}}</span>
          <span>
            <svg
              @click="handleLanguage('del')"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                fill="#C6C2C2"
              />
            </svg>
          </span>
        </div>
        <div class="item__selected" v-if="itemsSelected.currency.name">
          <span>{{itemsSelected.currency.name}}</span>
          <span>
            <svg
              @click="handleCurrency('del')"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                fill="#C6C2C2"
              />
            </svg>
          </span>
        </div>
        <div class="item__selected" v-if="itemsSelected.format.name">
          <span>{{itemsSelected.format.name}}</span>
          <span>
            <svg
              @click="handleFormat('del')"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                fill="#C6C2C2"
              />
            </svg>
          </span>
        </div>
        <div class="remove__all" @click="removeAll" v-if="isFirstTouch">
          <span v-html="t.label_remove_filters"></span>
        </div>
      </div>
		<div class="input__out">
			<svg class="magnify" width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M14.7931 12.9681L11.8721 10.0471C11.8065 9.98148 11.7285 9.92957 11.6427 9.89438C11.5568 9.85919 11.4648 9.84141 11.3721 9.84208H10.9001C11.8528 8.61907 12.3033 7.07874 12.1597 5.53509C12.016 3.99144 11.289 2.56068 10.127 1.53449C8.96487 0.508303 7.45517 -0.0360599 5.9056 0.0123751C4.35603 0.06081 2.88327 0.698396 1.78755 1.79516C0.691821 2.89192 0.0556273 4.36528 0.0086577 5.9149C-0.0383119 7.46451 0.507479 8.9737 1.53477 10.1348C2.56205 11.2959 3.9935 12.0215 5.53728 12.1637C7.08107 12.3059 8.62098 11.854 9.84308 10.9001V11.3771C9.84241 11.4698 9.86019 11.5618 9.89538 11.6477C9.93058 11.7335 9.98248 11.8115 10.0481 11.8771L12.9691 14.7981C13.0341 14.8635 13.1115 14.9155 13.1967 14.9509C13.2819 14.9864 13.3733 15.0046 13.4656 15.0046C13.5579 15.0046 13.6492 14.9864 13.7345 14.9509C13.8197 14.9155 13.897 14.8635 13.9621 14.7981L14.7911 13.9691C14.8572 13.9036 14.9096 13.8257 14.9455 13.7399C14.9814 13.6541 15 13.562 15.0001 13.469C15.0003 13.376 14.9821 13.2838 14.9466 13.1979C14.9111 13.1119 14.8589 13.0338 14.7931 12.9681ZM6.09308 9.84208C5.3514 9.84208 4.62637 9.62214 4.00969 9.21009C3.393 8.79803 2.91236 8.21236 2.62853 7.52714C2.3447 6.84192 2.27044 6.08792 2.41513 5.36049C2.55983 4.63306 2.91698 3.96487 3.44143 3.44043C3.96587 2.91598 4.63406 2.55883 5.36149 2.41413C6.08892 2.26944 6.84292 2.3437 7.52814 2.62753C8.21336 2.91136 8.79903 3.392 9.21109 4.00869C9.62314 4.62537 9.84308 5.3504 9.84308 6.09208C9.84361 6.58473 9.74697 7.07265 9.55872 7.52791C9.37046 7.98318 9.09427 8.39685 8.74596 8.74525C8.39765 9.09366 7.98405 9.36995 7.52884 9.55833C7.07362 9.74671 6.58573 9.84347 6.09308 9.84308V9.84208Z" fill="#434343"/>
			</svg>
			<input type="text" v-model="inputSearch" />
			<svg class="close" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M7.5 0C6.01664 0 4.5666 0.439867 3.33323 1.26398C2.09986 2.08809 1.13856 3.25943 0.570907 4.62987C0.00324965 6.00032 -0.145275 7.50832 0.144114 8.96318C0.433503 10.418 1.14781 11.7544 2.1967 12.8033C3.2456 13.8522 4.58197 14.5665 6.03683 14.8559C7.49168 15.1453 8.99968 14.9968 10.3701 14.4291C11.7406 13.8614 12.9119 12.9001 13.736 11.6668C14.5601 10.4334 15 8.98336 15 7.5C15 5.51088 14.2098 3.60322 12.8033 2.1967C11.3968 0.790176 9.48913 0 7.5 0ZM11.177 9.469C11.2108 9.50272 11.2376 9.54278 11.2559 9.58688C11.2742 9.63098 11.2836 9.67825 11.2836 9.726C11.2836 9.77375 11.2742 9.82102 11.2559 9.86512C11.2376 9.90922 11.2108 9.94928 11.177 9.983L9.977 11.178C9.94328 11.2118 9.90323 11.2386 9.85913 11.2569C9.81503 11.2752 9.76775 11.2846 9.72 11.2846C9.67226 11.2846 9.62498 11.2752 9.58088 11.2569C9.53678 11.2386 9.49672 11.2118 9.463 11.178L7.5 9.194L5.531 11.178C5.49728 11.2118 5.45723 11.2386 5.41313 11.2569C5.36903 11.2752 5.32175 11.2846 5.274 11.2846C5.22626 11.2846 5.17898 11.2752 5.13488 11.2569C5.09078 11.2386 5.05072 11.2118 5.017 11.178L3.822 9.978C3.7882 9.94428 3.76138 9.90422 3.74308 9.86012C3.72478 9.81602 3.71536 9.76875 3.71536 9.721C3.71536 9.67325 3.72478 9.62598 3.74308 9.58188C3.76138 9.53778 3.7882 9.49772 3.822 9.464L5.806 7.5L3.822 5.531C3.7882 5.49728 3.76138 5.45722 3.74308 5.41312C3.72478 5.36902 3.71536 5.32175 3.71536 5.274C3.71536 5.22625 3.72478 5.17898 3.74308 5.13488C3.76138 5.09078 3.7882 5.05072 3.822 5.017L5.022 3.817C5.05572 3.7832 5.09578 3.75638 5.13988 3.73808C5.18398 3.71978 5.23126 3.71036 5.279 3.71036C5.32675 3.71036 5.37403 3.71978 5.41813 3.73808C5.46223 3.75638 5.50228 3.7832 5.536 3.817L7.5 5.806L9.469 3.822C9.50272 3.7882 9.54278 3.76138 9.58688 3.74308C9.63098 3.72478 9.67826 3.71536 9.726 3.71536C9.77375 3.71536 9.82103 3.72478 9.86513 3.74308C9.90923 3.76138 9.94928 3.7882 9.983 3.822L11.183 5.022C11.2168 5.05572 11.2436 5.09578 11.2619 5.13988C11.2802 5.18398 11.2896 5.23125 11.2896 5.279C11.2896 5.32675 11.2802 5.37402 11.2619 5.41812C11.2436 5.46222 11.2168 5.50228 11.183 5.536L9.194 7.5L11.177 9.469Z" fill="#C6C2C2"/>
			</svg>
		</div>
    </div>
    <div>
      <div class="button__out">
        <a @click="handleCreateProductLink()" class="button__add" v-html="t.label_create_product"></a>
      </div>
      <p v-html="t.label_create_new_product"></p>
    </div>
  </div>
</template>

<script>
import dropdown from "./dropdown";
export default {
  name: "super-checkout-intern-header",
  props: ["view"],
  data() {
    return {
      t: this.view.translation,
      allCountries: [],
      allNiches: [],
      allLanguages: [],
      valueSearch: '',
      timeoutSearch: null,
      isFirstTouch: false,
      itemsSelected: {
        price: {
            id: null,
            name: '',
            key: 0
        },
        percent_comission: {
            id: null,
            name: '',
            key: 50
        },
        country: {
            id: null,
            name: '',
            key: 100
        }, 
        language: {
            id: null,
            name: '',
            key: 150
        },
        currency: {
            id: null,
            name: '',
            key: 200
        },
        format: {
            id: null,
            name: '',
            key: 250
        }
      },
      price: {
        name: "",
        arrayOfObjects: [],
      },
      percent_comission: {
        name: "",
        arrayOfObjects: [
          { name: "0% - 20%" },
          { name: "20% - 40%" },
          { name: "40% - 60%" },
          { name: "60% - 80%" },
          { name: "80% - 100%" },
        ],
      },
      country: {
        name: "",
        arrayOfObjects: [],
      },
      language: {
        name: "",
        arrayOfObjects: [],
      },
      currency: {
        name: "",
        arrayOfObjects: [
          { name: "USD" },
          { name: "BRL" },
          { name: "EUR" },
        ],
      },
      format: {
        name: "",
        arrayOfObjects: [],
      },
    };
  },
  components: {
    dropdown: dropdown,
  },
  mounted() {
    // console.log(this.view.translation);
    this.handleSetObjePrice();
    this.handleGetAllFilters();
  },

  methods: {
    handlePrice(payload) {
        if(payload == 'del') {
            this.itemsSelected.price.name = false;
            this.itemsSelected.price.key++;
            this.handleSeachReq();
            return;
        }
        this.itemsSelected.price.name = payload.name;
        this.handleSeachReq();
        
    },
    handlePercentComission(payload) {
        if(payload == 'del') {
            this.itemsSelected.percent_comission.id = null;
            this.itemsSelected.percent_comission.name = false;
            this.itemsSelected.percent_comission.key++;
            this.handleSeachReq();
            return;
        }
        this.itemsSelected.percent_comission.name = payload.name;
        this.handleSeachReq();
    },
    handleCountry(payload) {
        if(payload == 'del') {
            this.itemsSelected.country.id = false;
            this.itemsSelected.country.name = false;
            this.itemsSelected.country.key++;
            this.handleSeachReq();
            return;
        }
        this.itemsSelected.country.id = payload.id;
        this.itemsSelected.country.name = payload.name;
        this.handleSeachReq();
    },
    handleLanguage(payload) {
        if(payload == 'del') {
            this.itemsSelected.language.name = false;
            this.itemsSelected.language.key++;
            this.handleSeachReq();
            return;
        }
        this.itemsSelected.language.name = payload.name;
        this.handleSeachReq();
    },
    handleCurrency(payload) {
        if(payload == 'del') {
            this.itemsSelected.currency.name = false;
            this.itemsSelected.currency.key++;
            this.handleSeachReq();
            return;
        }
        this.itemsSelected.currency.name = payload.name;
        this.handleSeachReq();
    },
    handleFormat(payload) {
        if(payload == 'del') {
            this.itemsSelected.format.id = false;
            this.itemsSelected.format.name = false;
            this.itemsSelected.format.key++;
            this.handleSeachReq();
            return;
        }
        this.itemsSelected.format.id = payload.id;
        this.itemsSelected.format.name = payload.name;
        this.handleSeachReq();
    },
    removeAll() {
        this.valueSearch = '';

        this.itemsSelected.price.id = false;
        this.itemsSelected.price.name = false;
        this.itemsSelected.price.key++;

        this.itemsSelected.percent_comission.id = false;
        this.itemsSelected.percent_comission.name = false;
        this.itemsSelected.percent_comission.key++;

        this.itemsSelected.country.id = false;
        this.itemsSelected.country.name = false;
        this.itemsSelected.country.key++;

        this.itemsSelected.language.id = false;
        this.itemsSelected.language.name = false;
        this.itemsSelected.language.key++;

        this.itemsSelected.currency.id = false;
        this.itemsSelected.currency.name = false;
        this.itemsSelected.currency.key++;

        this.itemsSelected.format.id = false;
        this.itemsSelected.format.name = false;
        this.itemsSelected.format.key++;

        this.handleSeachReq();
        this.isFirstTouch = false;
    },
    handleSeachReq(search = false) {
      this.isFirstTouch = true;
        let mountURL;
        mountURL =  "currency="   + (this.itemsSelected.currency.name          ? this.itemsSelected.currency.name                                            : '') +
                    // "&niche="     + (this.itemsSelected.niche.name             ? this.itemsSelected.niche.name                                            : '') +
                    "&language="  + (this.itemsSelected.language.name          ? this.itemsSelected.language.name                                            : '') +
                    "&priceMin="  + (this.itemsSelected.price.name             ? this.handleValueRemoveSignal(this.itemsSelected.price.name, 'min')          : '') +
                    "&priceMax="  + (this.itemsSelected.price.name             ? this.handleValueRemoveSignal(this.itemsSelected.price.name, 'max')          : '') +
                    "&country="   + (this.itemsSelected.country.id             ? this.itemsSelected.country.id                                               : '') +
                    "&format="    + (this.itemsSelected.format.id              ? this.itemsSelected.format.id                                                : '') +
                    "&comission=" + (this.itemsSelected.percent_comission.name ? this.handleValuePercentComission(this.itemsSelected.percent_comission.name) : '');
        
        if(this.valueSearch) mountURL = mountURL + '&search=' + this.valueSearch;
        // console.log(mountURL);
        this.$parent.handleAllCards(mountURL);
    },
    handleValue() {
      if(this.view.data.currency == 'USD') return '$';
      if(this.view.data.currency == 'BRL') return 'R$';
      if(this.view.data.currency == 'EUR') return '€';
    },
    handleSetObjePrice() {
      this.price.arrayOfObjects = [
          { name: `${this.handleValue()}0.00 - ${this.handleValue()}100.00` },
          { name: `${this.handleValue()}100.00 - ${this.handleValue()}300.00` },
          { name: `${this.handleValue()}300.00 - ${this.handleValue()}500.00` },
          { name: `${this.handleValue()}500.00 - ${this.handleValue()}1000.00` },
          { name: `${this.handleValue()}1000.00 - ${this.handleValue()}1500.00` },
          { name: `${this.handleValue()}1500.00 - ${this.handleValue()}3000.00` },
      ];
    },
    handleValueRemoveSignal(value, type) {
      if(value) {
        let valSplited = value.split('-');
        if(type == 'min') return valSplited[0].replace(this.handleValue(), '').replace(/\s/g, '').replace('.', '');
        if(type == 'max') return valSplited[1].replace(this.handleValue(), '').replace(/\s/g, '').replace('.', '');
      }
    },
    handleValuePercentComission(value) {
      if(value) {
        let valSplited = value.split('-');
        return valSplited[1].replace('%', '').replace(/\s/g, '');
      }
    },
    handleGetAllFilters() {
        var vm = this;
        vm.loading = true;
        axios.get(
            this.view.routes.rota_office_super_checkout_intern_request_filters,
        )
        .then(function (response) {
            vm.loading = false;
            let niches = [];
            let countries = [];
            let languages = [];

              Object.keys(response.data.niches).map(function(key, index) {
                niches.push(response.data.niches[key]);
            });
            Object.keys(response.data.countries).map(function(key, index) {
                countries.push(response.data.countries[key]);
            });
            Object.keys(response.data.languages).map(function(key, index) {
                response.data.languages[key].name = response.data.languages[key].name.toUpperCase();
                languages.push(response.data.languages[key]);
            });

            vm.format.arrayOfObjects = niches;
            vm.country.arrayOfObjects = countries;
            vm.language.arrayOfObjects = languages;
        })
        .catch(function (error) {
            // handle error
            console.log(2,error);
        })
	},
	handleCreateProductLink() {
		// if(this.$parent.view.data.is_affiliate) {

			window.location.replace(this.$parent.view.routes.rota_office_cheetah_builder);
		// } else {
		// 	$('#modal-upgrade-by-tool').modal('show'); //modals.phtml
		// }
	},
  },

    computed: {
        inputSearch: {
            get() {
                return this.valueSearch;
            },
            set(val) {
                if (this.timeoutSearch) clearTimeout(this.timeoutSearch);
                this.timeoutSearch = setTimeout(() => {
                    this.valueSearch = val;
                    this.handleSeachReq();
                    return val;
                }, 300);
            }
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
	display: flex;
	flex-direction: column;
	.button__out {
		display: flex;
		justify-content: flex-start;
		.button__add {
			background: #0080FC;
			padding: 1.4rem 3rem;
			font-size: 1.1rem;
      margin-bottom: 1rem;
			color: white;
			border-radius: 7px;
		}
	}
  .topper {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 10px;
    margin-bottom: 1rem;
  }
  .footter {
    display: flex;
    justify-content: space-between;
    grid-template-columns: repeat(6, 1fr);
    margin-bottom: 1rem;
    .items {
      display: flex;
      flex-wrap: wrap;
      .item__selected {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #e5e5e5;
        border-radius: 34px;
        padding: 0.6rem 0.8rem;
        margin: 0.5rem 0.8rem;
        span {
          &:first-child {
            color: #5b5b5b;
            font-weight: 700;
          }
          &:last-child {
            margin-left: 0.5rem;
            cursor: pointer;
          }
        }
      }
      .remove__all {
        display: flex;
        align-items: center;
        cursor: pointer;
        background: #e5e5e5;
        border: 1px solid #66b3ff;
        border-radius: 34px;
        color: #0080fc;
        font-size: 0.9rem;
        padding: 0.6rem 0.8rem;
        margin: 0.5rem 0.8rem;
      }
    }
  }
}
.input__out {
        position: relative;
        .magnify {
            position: absolute;
            left: 0;
            top: 10px;
        }
        svg {
            cursor: pointer;
        }
        input {
            background: transparent;
            width: 100%;
            border: none;
            border-bottom: 2px solid #0294FF;
            padding: 0 20px;
            height: 40px;
            &:focus {
                overflow: auto;
                outline: none;
                -webkit-box-shadow: none;
                -moz-box-shadow: none;
                box-shadow: none;
            }
        }
        .close {
            position: absolute;
            right: 0;
            top: 10px;
        }
    }
@media (max-width: 1050px) {
  .header .topper {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/super-checkout-intern/header.vue